import axios from 'axios';
import { merge } from 'app/utils';

type ProcessPensioenbijMutationsArgs = {
  connectionId: string;
  eventIds: string[];
  filters?: Record<string, unknown>;
  searchQuery?: string;
  selectAll: boolean;
  isDraft?: boolean;
};

export const processPensioenbijMutations = async ({
  connectionId,
  eventIds,
  filters,
  searchQuery,
  selectAll,
  isDraft,
}: ProcessPensioenbijMutationsArgs) => {
  return axios.post(`/connections/${connectionId}/mutations/pensioenbij/process`, {
    connectionId,
    eventIds,
    filters: merge(
      {
        employee: searchQuery,
      },
      filters,
    ),
    selectAll,
    isDraft,
  });
};

type ProcessPensioenbijOnboardingMutationsArgs = {
  connectionId: string;
};

export const processPensioenbijOnboardingMutations = async ({
  connectionId,
}: ProcessPensioenbijOnboardingMutationsArgs) => {
  return axios.post(`/connections/${connectionId}/mutations/pensioenbij/onboarding-batch`, {
    connectionId,
  });
};
